import type { CssGeneratorContext } from '../css-generator.model';

export const styles = ({ dt }: CssGeneratorContext) => `.inspection-step-blocked-view .blocked-title {
  font-weight: ${dt('inspectionStepBlockedView.title.fontWeight')};
  font-size: ${dt('inspectionStepBlockedView.title.fontSize')};
  color: ${dt('inspectionStepBlockedView.title.color')};
}

.inspection-step-blocked-view .blocked-message {
  color: ${dt('inspectionStepBlockedView.message.color')};
}

.inspection-step-loading-overlay {
  background: ${dt('inspectionStepBlockedView.loadingOverlay.background')};
}`;
